import { interpolateStringWithData } from 'utils';

/** CMS microcopy set `mini-cart`, with the English defaults. */
export const MINI_CART_MICROCOPY_SET = 'mini-cart';

export const MINI_CART_MICROCOPY_DEFAULTS = {
  'mini-cart.save-for-later-error': "Couldn't save for later, try again",
  // A removal or seat change the server refused; the cart shows what it holds.
  'mini-cart.update-error': "Couldn't update your cart, try again",
  // Announced when the open cart could not be read.
  'mini-cart.load-error': "Couldn't load your cart, try again",
  'mini-cart.dismiss': 'Dismiss',
  // Another tab moved the cart to another org; this tab's page is for the old one.
  'mini-cart.organization-changed':
    'Your organization changed in another tab. Reload to see your cart.',
  'mini-cart.reload': 'Reload',
  // The header cart button; {{label}} is the CMS header link text.
  'mini-cart.trigger-label': 'View {{label}}',
  'mini-cart.trigger-label-count-one': 'View {{label}} ({{count}} item)',
  'mini-cart.trigger-label-count-other': 'View {{label}} ({{count}} items)',
  // Announced politely when the header count changes.
  'mini-cart.count-announcement-one': 'Cart updated, {{count}} item',
  'mini-cart.count-announcement-other': 'Cart updated, {{count}} items',
};

/** The `-one`/`-other` variant of a counted string, filled in. */
export const formatMiniCartCount = (
  mc: Record<string, string>,
  key: 'mini-cart.trigger-label-count' | 'mini-cart.count-announcement',
  values: { count: number } & Record<string, string | number>
): string =>
  interpolateStringWithData(
    mc[`${key}-${values.count === 1 ? 'one' : 'other'}`],
    values
  );

/**
 * The header cart button's name: `label` is the CMS link text; an
 * `undefined` count (hidden badge) leaves the count out.
 */
export const formatMiniCartTriggerLabel = (
  mc: Record<string, string>,
  label: string,
  count: number | undefined
): string =>
  count === undefined
    ? interpolateStringWithData(mc['mini-cart.trigger-label'], { label })
    : formatMiniCartCount(mc, 'mini-cart.trigger-label-count', {
        count,
        label,
      });
